/**
 * アプリケーション定数
 */

/** API関連定数 */
export const API_CONSTANTS = {
  /** デフォルトBase URL */
  DEFAULT_BASE_URL: 'https://api-stg.out.inventory-report.p-garage.jp/api/',
  /** 一覧取得エンドポイント（相対パス） */
  LIST_SEARCH_ENDPOINT: 'list/97dc2fcf-ca10-4947-8d05-fc486caeabbb/search',
} as const;

/** localStorage キー */
export const STORAGE_KEYS = {
  COLUMN_SETTINGS: 'prosche_column_settings',
  FILTER_SETTINGS: 'prosche_filter_settings',
  CURRENT_TAB: 'prosche_current_tab',
  API_BASE_URL: 'prosche_api_base_url',
  TOKEN_ENABLED: 'prosche_token_enabled',
  TOKEN_VALUE: 'prosche_token_value',
  COPY_SELECTION_WITH_HEADERS: 'prosche_copy_selection_with_headers',
  GROUP_STATE: 'prosche_group_state',
} as const;

/** フィールド名マッピング（命名揺れ吸収） */
export const FIELD_NAME_MAPPING: Record<string, string> = {
  shipPlannedDate: 'shipPlanningDate',
  // TODO: 追加の命名揺れがあればここに追記
} as const;

/** データ型ごとのデフォルト演算子 */
export const DEFAULT_OPERATORS_BY_TYPE = {
  string: ['in', 'notIn', 'contains', 'notContains', 'equals', 'notEquals', 'startsWith', 'endsWith', 'isEmpty', 'isNotEmpty'],
  number: ['equals', 'notEquals', 'greaterThan', 'lessThan', 'greaterThanOrEqual', 'lessThanOrEqual', 'isEmpty', 'isNotEmpty'],
  date: ['equals', 'notEquals', 'greaterThan', 'lessThan', 'greaterThanOrEqual', 'lessThanOrEqual', 'isEmpty', 'isNotEmpty'],
  boolean: ['equals', 'notEquals'],
} as const;

/** 演算子の日本語ラベル */
export const OPERATOR_LABELS: Record<string, string> = {
  equals: '等しい',
  notEquals: '等しくない',
  contains: '含む',
  notContains: '含まない',
  startsWith: 'で始まる',
  endsWith: 'で終わる',
  greaterThan: 'より大きい',
  lessThan: 'より小さい',
  greaterThanOrEqual: '以上',
  lessThanOrEqual: '以下',
  in: '次のいずれか',
  notIn: '次のいずれでもない',
  isEmpty: '空である',
  isNotEmpty: '空でない',
} as const;
